import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, Overline } from "./primitives";

const FAQS = [
  {
    q: "Siete mormoni?",
    a: "No. Siamo cristiani evangelici e ci definiamo discepoli di Gesù. Il nostro riferimento è Gesù Cristo e la Bibbia. Tempio Vivo è un progetto di coaching.",
  },
  {
    q: "Volete indottrinarmi?",
    a: "La nostra identità cristiana è dichiarata. Ti spieghiamo come lavoriamo e rispettiamo la tua libertà. Non devi aderire a una denominazione religiosa per parlare con noi.",
  },
  {
    q: "Devo essere già credente?",
    a: "Puoi avvicinarti anche se hai dubbi o sei in ricerca. La community ha un'identità cristiana: puoi conoscerla e valutare se questo ambiente è coerente con ciò che cerchi.",
  },
  {
    q: "Sostituite il pastore o il sacerdote?",
    a: "No. Non celebriamo sacramenti e non sostituiamo la guida della tua comunità religiosa. Lavoriamo su obiettivi, abitudini e azioni quotidiane.",
  },
  {
    q: "È psicoterapia?",
    a: "No. Il coaching non è psicoterapia e non formula diagnosi. Quando emerge un bisogno diverso, è importante coinvolgere il professionista competente.",
  },
  {
    q: "Ho paura del giudizio. Posso parlare di cose difficili?",
    a: "Sì. Puoi cominciare da ciò che ti senti di condividere. Ti ascoltiamo con rispetto e riservatezza.",
  },
  {
    q: "Dove siete?",
    a: "Elio e Chiara vivono a Malta. I percorsi si svolgono online. Eventuali incontri dal vivo vengono comunicati quando organizzati.",
  },
  {
    q: "Quanto costa?",
    a: "Modalità, durata e costo dei percorsi vengono presentati con chiarezza prima dell'adesione. La Mappa del Tempio è il primo passo: nell'incontro con Elio capisci quale opzione è pertinente alla tua situazione.",
  },
  {
    q: "Che cos'è la Mappa del Tempio?",
    a: "È il primo passo: un incontro privato e gratuito di 30 minuti con Elio. Guardate insieme la tua situazione, individuate la battaglia prioritaria e ricevi una direzione concreta. Senza obblighi: si prenota dal calendario con il pulsante in pagina.",
  },
];

export const FaqSection = () => (
  <section id="faq" className="relative bg-white/[0.02] py-28 sm:py-36" data-testid="faq-section">
    <div className="mx-auto max-w-4xl px-6 sm:px-8">
      <Reveal>
        <Overline>Domande frequenti</Overline>
        <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.02] tracking-tight text-white">
          Le risposte, <span className="italic text-gold">senza giri di parole.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.12}>
        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-white/15"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-5 text-left font-serif text-lg sm:text-xl font-medium text-white hover:text-gold hover:no-underline [&[data-state=open]]:text-gold">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base font-light leading-relaxed text-white/75">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
